export default function BackgroundBlur() {
  return (
    <>
      <div className="absolute top-0 right-0 -mt-32 -mr-32 w-96 h-96 bg-[#1d57a5]/5 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute bottom-0 left-0 -mb-32 -ml-32 w-96 h-96 bg-[#36a852]/5 rounded-full blur-3xl pointer-events-none" />
    </>
  );
}
